import React from 'react'
import ComponentLoader from 'components/ComponentLoader/index.js'
import { logUtil } from 'packages/src'
import { shouldShowOnboardingModalProfileAction } from 'modules/profile/redux/actions/should-show-fitness-data-modal/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getLocationRouterSelect from 'modules/router/selectors/get-location/index.js'

function loadComponent () {
  return import(/* webpackChunkName: "containers/OnboardingModal/Content" */ 'containers/OnboardingModal/Content')
}

const ANALYTIC_EVENT = {
  SHOW_ONBOARDING_PROFILE_FITNESS_DATA_MODAL: 'SHOW_ONBOARDING_PROFILE_FITNESS_DATA_MODAL',
  HIDE_ONBOARDING_PROFILE_FITNESS_DATA_MODAL: 'HIDE_ONBOARDING_PROFILE_FITNESS_DATA_MODAL'
}

export default function OnboardingModal () {
  const [shouldShow, setShouldShow] = React.useState()
  const debugProps = { shouldShow }
  logUtil('OnboardingModal').debug('[start] debugProps=', debugProps)
  const dispatch = useDispatch()
  const location = useSelector(getLocationRouterSelect)

  const handleShouldShow = async () => {
    const res = await dispatch(
      shouldShowOnboardingModalProfileAction()
    )

    if (!res) {
      return
    }

    setShouldShow(true)
    logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_ONBOARDING_PROFILE_FITNESS_DATA_MODAL)
  }

  React.useEffect(() => {
    handleShouldShow()
  }, [location])

  const handleUnmount = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.HIDE_ONBOARDING_PROFILE_FITNESS_DATA_MODAL)
  }

  React.useEffect(() => {
    return handleUnmount
  }, [])

  if (!shouldShow) {
    logUtil('OnboardingModal').debug('[noop] should not show')
    return <></>
  }

  return (
    <ComponentLoader
      loadComponent={loadComponent}
      shouldNotShowLoader
    />
  )
}
